import {Badge, Box, IconButton} from "@radix-ui/themes";
import FontAwesome from "../../utilities/FontAwesome";
import {MessagingListQueryOptions, MessagingListRulesQuery} from "../../modals/Messaging/MessagingListRules";
import {gradeTypeToValueMap} from "../../modals/Messaging/MessagingListRuleQueryBuilder";
import {PropsWithChildren} from "react";

function RecipientBadgeContainer(props: PropsWithChildren<{
    removeBadge: () => void,
}>) {
    return <Box display={"inline-block"} pr={"1"} pb={"1"}>
        <Badge size={"3"}>
            {props.children}<IconButton variant={"ghost"} size={"1"} onClick={props.removeBadge}>
            <FontAwesome name={"fa-times"} prefix={"fas"}/>
        </IconButton>
        </Badge>
    </Box>
}

export function RecipientUserBadge(props: {
    user: IUser,
    removeUser: () => void,
}) {
    return <RecipientBadgeContainer removeBadge={props.removeUser}>
        {props.user.fname} {props.user.lname}
    </RecipientBadgeContainer>
}

function displayNameFromRule(rule: MessagingListRulesQuery) {
    let displayName = "";
    if (rule[MessagingListQueryOptions.Grade]?.filter) {
        displayName += gradeTypeToValueMap[rule[MessagingListQueryOptions.Grade].filter] + " "
    }
    displayName += rule[MessagingListQueryOptions.Group]?.value + " at " + rule[MessagingListQueryOptions.Organization]?.value;
    return displayName;
}

export function RecipientRuleBadge(props: {
    rule: MessagingListRulesQuery,
    removeRule: () => void,
}) {
    return <RecipientBadgeContainer removeBadge={props.removeRule}>
        {displayNameFromRule(props.rule)}
    </RecipientBadgeContainer>
}